const INIT_STATE = {
  level: '',
  products: ''
};

const FilterData = (state = INIT_STATE, action) => {
  switch (action.type) {
    case 'FILTER_DATA':
      return {
        ...state,
        level: action.payload.level,
        products: action.payload.products
      };
    default:
      return state;
  }
};

export default FilterData;
